<template>
  <div class="compare-wrap m-t-20">
    <div v-if="isOperate" class="flex-align__between">
      <div>
        <template v-if="allowFlow">
          <el-button type="danger m-b-10" @click="$emit('cancelCandidate')">
            取消部分采购
          </el-button>
          <el-tooltip
            class="item"
            effect="dark"
            content="取消部分采购后的品目将退回至采购任务中，若需继续采购可重新制定采购方案，若不继续采购，可在采购任务中作废处理"
            placement="top-start"
          >
            <i class="el-icon-question font-16 m-l-6 text-warning"></i>
          </el-tooltip>
        </template>
      </div>

      <div class="flex col-center m-b-10">
        <div class="compare-tips flex-align__between m-r-12">
          <div class="compare-tips__item lowest flex-align">最低价</div>
          <div class="compare-tips__item highest flex-align">最高价</div>
        </div>
        <div class="m-r-10">
          <span class="m-r-8">供应商排序</span>
          <el-select
            v-model="sortType"
            placeholder="请选择"
            style="width: 160px"
            @change="handleChangeSort"
          >
            <el-option
              v-for="item in sortTypeOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div v-if="inMultiple" class="multiple-tips">
          <span class="multiple-tips__important">
            选择需要进行多轮报价的品目
          </span>
          <span>未选择进行多轮报价的品目，将保留上一次的报价结果</span>
        </div>

        <el-button
          v-if="exportPriceComparison"
          type="primary"
          @click="handleExportPdf"
        >
          导出pdf
        </el-button>
        <template v-else-if="needGrand">
          <el-button type="primary" @click="handleSelectLowest">
            一键选择分项最低
          </el-button>

          <el-button type="primary" @click="handleSelectLowestTotal">
            一键选择总价最低
          </el-button>
        </template>

        <el-button
          v-if="!needGrand && !inMultiple"
          type="primary"
          @click="exportCompareInfo"
        >
          导出比价单结果
        </el-button>
        <!---- 采购方案：10 不列入字典------>
        <table-header-setting
          v-if="!inMultiple"
          class="m-l-10"
          :table-config="listOption"
          :purchase-type="10"
          @refresh="getHeader"
        />
      </div>
    </div>

    <!-- :height="tableHeight" -->
    <el-table
      ref="table"
      :key="tableKey"
      max-height="500"
      border
      :data="pageTableData"
      :span-method="objectSpanMethod"
      row-key="rowKey"
      :header-cell-style="{ background: '#f5f5f5' }"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        v-if="inMultiple || isSelection"
        type="selection"
        width="55"
        reserve-selection
      />
      <el-table-column
        align="center"
        label="序号"
        prop="index"
        type="index"
        :index="indexMethod"
        width="50"
        fixed
      />
      <el-table-column
        align="center"
        show-overflow-tooltip
        label="品目名称"
        prop="materielName"
        width="110"
        fixed
      >
        <template slot-scope="{ row }">
          <span>{{ row.materielName || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showTableColumn('materielCode')"
        align="center"
        label="品目编码"
        show-overflow-tooltip
        prop="materielCode"
        width="80"
        fixed
      >
        <template slot-scope="{ row }">
          <span>{{ row.materielCode || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showTableColumn('materielNum')"
        align="center"
        label="数量"
        show-overflow-tooltip
        prop="materielNum"
        width="80"
        fixed
      >
        <template slot-scope="{ row }">
          <span>
            {{ row.materielNum ? strToThousands(row.materielNum) : 0 }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showTableColumn('materielModel')"
        align="center"
        label="参数型号"
        show-overflow-tooltip
        prop="materielModel"
        width="100"
        fixed
      >
        <template slot-scope="{ row }">
          <span>{{ row.materielModel || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showTableColumn('materielBrand')"
        align="center"
        label="品牌/制造商"
        show-overflow-tooltip
        prop="materielBrand"
        min-width="110"
      >
        <template slot-scope="{ row }">
          <span>{{ row.materielBrand || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showTableColumn('deliveryAddress')"
        align="center"
        label="交货地点"
        show-overflow-tooltip
        prop="deliveryAddress"
        width="90"
      >
        <template slot-scope="{ row }">
          <span>{{ row.deliveryAddress || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showTableColumn('deliveryDay')"
        align="center"
        label="交货时间(天)"
        show-overflow-tooltip
        prop="deliveryDay"
        width="110"
      >
        <template slot-scope="{ row }">
          <span>{{ row.deliveryDay || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showAward"
        align="center"
        label="授标量"
        show-overflow-tooltip
        width="80"
      >
        <template slot-scope="{ row }">
          <span
            :class="{
              'text-warning':
                parseFloat(getAwardNum(row)) > parseFloat(row.materielNum)
            }"
          >
            {{ strToThousands(getAwardNum(row)) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showTableColumn('totalPrice')"
        align="center"
        :label="`预算总价(${isDollar ? '美元' : '元'})`"
        show-overflow-tooltip
        width="160"
      >
        <template slot-scope="{ row }">
          <div>
            {{ row.totalPrice ? strToThousands(row.totalPrice) : '-' }}
            <money-in-cn
              v-if="!isDollar"
              :money="row.totalPrice"
              :ellipsis="false"
            />
          </div>
          <div v-if="row.targetTotalPrice">
            目标总价:
            {{
              row.targetTotalPrice ? strToThousands(row.targetTotalPrice) : '-'
            }}
          </div>
        </template>
      </el-table-column>
      <!-- 供应商 -->
      <el-table-column
        v-for="item in supplierHead"
        :key="item.supplierName"
        :label="`${item.supplierName}`"
        align="center"
      >
        <template #header>
          <a-checkbox
            v-if="showCheckbox"
            style="display: flex; align-items: center"
            :checked="item.checkAll"
            :indeterminate="item.isIndeterminate"
            @change="handleSupplierCheck(item)"
          >
            <div>
              <span>{{ item.supplierName }}</span>
            </div>
            <div class="flex col-stretch row-center flex-wrap">
              <div style="white-space: nowrap">报价总金额：</div>
              <div class="flex flex-column col-top">
                {{
                  item.noRateOfferAmount
                    ? strToThousands(item.noRateOfferAmount)
                    : 0
                }}
                {{ isDollar ? '美元' : '元' }}
              </div>
            </div>
            <div v-if="showReviewScore">评审得分：{{ item.reviewScore }}</div>
          </a-checkbox>
          <template v-else>
            <div>
              <span>{{ item.supplierName }}</span>
              <template v-if="!item.offerAmount">
                （
                <span class="text-danger">
                  {{ getSupplierOfferLabel(item) }}
                </span>
                ）
              </template>
            </div>
            <div class="flex col-stretch row-center flex-wrap">
              <div style="white-space: nowrap">报价总金额：</div>
              <div class="flex flex-column col-top">
                {{
                  item.noRateOfferAmount
                    ? strToThousands(item.noRateOfferAmount)
                    : 0
                }}
                {{ isDollar ? '美元' : '元' }}
              </div>
            </div>
            <div v-if="showReviewScore">评审得分：{{ item.reviewScore }}</div>
          </template>
        </template>

        <el-table-column v-if="needGrand" align="center" label="授标">
          <template slot="header">
            <span class="text-primary">授标</span>
          </template>
          <template slot-scope="{ row }">
            <div class="flex-align__around">
              <a-checkbox
                :checked="getGrandCheck(row, item).check"
                style="margin-right: 0.5rem;"
                :disabled="!getGrandCheck(row, item).detailId"
                @change="checkChange(row, item)"
              />
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" width="120" label="品牌/制造商">
          <template slot-scope="{ row }">
            <div
              :class="
                row.materielBrand != getOfferValue(row, item).offerMaterielBrand
                  ? 'text-danger text-bold'
                  : ''
              "
            >
              {{ getOfferValue(row, item).offerMaterielBrand || '-' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          width="120"
          :label="`不含税单价(${isDollar ? '美元' : '元'})`"
        >
          <template slot-scope="{ row }">
            <div :style="{ 'text-align': 'right' }">
              {{ getOfferValue(row, item).noRateOfferPrice || '-' }}
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" width="120" label="税率(%)">
          <template slot-scope="{ row }">
            <div>
              {{ getOfferValue(row, item).offerTaxRate || '-' }}
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" width="120" label="交货周期(天)">
          <template slot-scope="{ row }">
            <div>
              {{ getOfferValue(row, item).offerDeliveryDay || '-' }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          width="120"
          :label="`不含税总价(${isDollar ? '美元' : '元'})`"
        >
          <template slot-scope="{ row }">
            <div
              :class="getOfferColor(row, item)"
              :style="{ 'text-align': 'right' }"
            >
              {{ getOfferValue(row, item).noRateTotalPrice || '-' }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column
        v-if="showTableColumn('budgetUnitPrice')"
        align="center"
        :label="`预算单价(${isDollar ? '美元' : '元'})`"
        show-overflow-tooltip
        width="140"
      >
        <template slot-scope="{ row }">
          <div>
            {{
              row.budgetUnitPrice ? strToThousands(row.budgetUnitPrice) : '-'
            }}
          </div>
          <div v-if="row.targetPrice">
            目标单价:
            {{ row.targetPrice ? strToThousands(row.targetPrice) : '-' }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        :label="`最低单价(${isDollar ? '美元' : '元'})`"
        show-overflow-tooltip
        width="140"
      >
        <template slot-scope="{ row }">
          <span>
            {{
              row.lowOffer
                ? row.lowOffer.offerPrice
                  ? strToThousands(row.lowOffer.offerPrice)
                  : row.lowOffer.offerPrice
                : '-'
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="最低单价报价供应商"
        show-overflow-tooltip
        width="180"
      >
        <template slot-scope="{ row }">
          {{ row.lowOffer ? row.lowOffer.supplierName || '-' : '-' }}
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="tableDataTemp.length > size"
      :total="tableDataTemp.length / spanNum"
      size="small"
      :page.sync="page"
      :limit.sync="size"
    />
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import MoneyInCn from '@/components/common/MoneyInCn'
import TableHeaderSetting from '@/components/common/TableHeaderSetting'

import { generateMaterielOfferHtml } from '@/components/common/PurchaseListComponent/generate-materiel-offer-html'

import { getInquiryOfferComparePdfApi } from '@/api/procure/inquiry'
import { getHeaderSettingApi } from '@/api/project-view'
import { getFileUrlByFileIdApi, htmlToPdfApi } from '@/api/up-file'

import { watermarkTypeDict } from '@/dictionary/template'
import { sortTypeDict, awardMethodDict } from '@/dictionary/project/inquiry'

import { strToThousands, roundNumHandle } from '@/utils/utils'
import { cloneDeep } from 'lodash'
import { inviteStatusDict } from '@/dictionary/project/common'
export default {
  name: 'CompareSheet',

  components: {
    Pagination,
    MoneyInCn,
    TableHeaderSetting
  },

  props: {
    tableData: {
      type: Array,
      default: () => []
    },

    headerList: {
      type: Array,
      default: () => []
    },

    // 已选择的品目id
    echoList: {
      type: Array,
      default: () => []
    },

    // 需要授标操作
    needGrand: {
      type: Boolean,
      default: false
    },

    // 是否可以多选表格项
    isSelection: {
      type: Boolean,
      default: false
    },

    // 发起多轮报价中
    inMultiple: {
      type: Boolean,
      default: false
    },

    // 导出询比比价单
    exportPriceComparison: {
      type: Boolean,
      default: false
    },

    // 需要跨越的行
    spanNum: {
      type: Number,
      default: 1
    },

    // 授标类型
    awardType: {
      type: [Number, String],
      default: ''
    },

    // 是否展示授标量
    showAward: {
      type: Boolean,
      default: false
    },

    // 是否美元报价
    isDollar: {
      type: Boolean,
      default: false
    },

    roundId: {
      type: [Number, String],
      default: ''
    },

    requireTax: {
      type: Boolean,
      default: false
    },

    // 是否显示评审得分
    showReviewScore: {
      type: Boolean,
      default: false
    },

    /**
     * 是否展示上面操作行
     */
    isOperate: {
      type: Boolean,
      default: true
    },

    // 使用允许部分品目流标
    allowFlow: {
      type: Boolean,
      default: false
    },

    // 邀请供应商列表
    inviteSupplierList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      showTips: true,

      tableDataTemp: [],
      // 前端模拟分页
      page: 1,
      size: 20,
      pageTableData: [],

      // 排序方式
      sortType: sortTypeDict.OFFER_PRICE_ASC.value,
      // 排序方式选项字典
      sortTypeDict,

      tableHeight: null,

      // 供应商报价表头
      supplierHead: [],
      tableKey: false,

      headerInfo: ''
    }
  },

  computed: {
    orderId() {
      return Number(this.$route.params.orderId || 0)
    },
    indexMethod() {
      return index => {
        return Math.round(index / this.spanNum + 1)
      }
    },

    sizeMultiple() {
      return this.size * this.spanNum
    },

    // 显示勾选框
    showCheckbox() {
      return this.needGrand
    },

    listOption() {
      const totalOptions = [
        {
          label: '品目名称',
          prop: 'materielName',
          fixed: true
        },
        {
          label: '品目编码',
          prop: 'materielCode'
        },
        {
          label: '数量',
          prop: 'materielNum'
        },
        {
          label: '参数型号',
          prop: 'materielModel'
        },
        {
          label: '品牌/制造商',
          prop: 'materielBrand'
        },
        {
          label: '交货地点',
          prop: 'deliveryAddress'
        },
        {
          label: '交货时间(天)',
          prop: 'deliveryDay'
        },
        {
          label: `预算单价(${this.isDollar ? '美元' : '元'})`,
          prop: 'budgetUnitPrice'
        },
        {
          label: `预算总价(${this.isDollar ? '美元' : '元'})`,
          prop: 'totalPrice'
        }
      ]
      return totalOptions.map(el => {
        if (this.headerInfo.includes(el.prop) || el.prop === 'materielName') {
          el.isShow = true
        } else {
          el.isShow = false
        }
        el.hide = !el.isShow
        return el
      })
    },

    listOptionObj() {
      const obj = {}
      this.listOption.forEach(el => {
        obj[el.prop] = el
      })
      return obj
    },

    sortTypeOption() {
      if (this.showReviewScore) {
        return sortTypeDict.array
      }
      return [sortTypeDict.OFFER_PRICE_ASC, sortTypeDict.OFFER_PRICE_DESC]
    }
  },

  watch: {
    headerList: {
      handler(val) {
        if (val.length > 0) this.setSupplierHead()
      },
      deep: true
    },

    echoList: {
      handler(val) {
        this.getIntersectionAndSelect()
      },
      immediate: true
    },

    tableData: {
      handler(val) {
        this.tableDataTemp = val.map((value, index) =>
          Object.assign({}, value, { rowKey: `${value.materielId}-${index}` })
        )

        this.getPageData()
        this.getIntersectionAndSelect()
        this.$nextTick(() => {
          this.supplierHead.forEach(item => {
            item.checkedMaterial = []
            item.someDisabled = 0
            for (
              let i = this.spanNum - 1;
              i < this.tableDataTemp.length;
              i += this.spanNum
            ) {
              const offerValue =
                this.tableDataTemp[i].offerValue[item.supplierId] || {}
              if (offerValue.check) {
                item.checkedMaterial.push(this.tableDataTemp[i].materielId)
              }
              if (!offerValue.detailId) {
                item.someDisabled++
              }
            }
            // 检查当前供应商是否所有品目都授标
            const checkAll =
              item.checkedMaterial.length ===
              this.tableDataTemp.length / this.spanNum - item.someDisabled
            // 检查当前供应商是否有部分品目授标
            const someCheck = item.checkedMaterial.length > 0
            item.isIndeterminate = !checkAll && someCheck
            item.checkAll = checkAll
          })
        })
      },
      deep: true
    },

    page() {
      this.getPageData()
    },
    size() {
      this.getPageData()
    },

    showReviewScore(val) {
      if (val) {
        // 线上评审项目，默认按评审得分降序排序
        this.sortType = sortTypeDict.SCORE_DESC.value
      }
    }
  },

  created() {
    this.getHeader()
  },

  mounted() {
    this.$nextTick(() => {
      this.getTableHeight()
    })
    window.addEventListener('resize', this.getTableHeight)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.getTableHeight)
    // 一定记得在页面关闭前销毁监听的resize事件，不然多次刷新后页面会因为内存泄漏崩溃
  },

  methods: {
    strToThousands,
    roundNumHandle,

    /**
     * 获取table高度
     */
    getTableHeight() {
      if (this.needGrand) {
        this.tableHeight = 500
      } else {
        this.tableHeight = window.innerHeight - 400
      }
    },

    /**
     * 是否展示某一列
     */
    showTableColumn(id) {
      return this.listOptionObj[id]?.isShow
    },

    /**
     * 获取表头设置
     */
    async getHeader() {
      try {
        const { data } = await getHeaderSettingApi(10)
        this.headerInfo = data.headerList || ''
        this.tableKey = !this.tableKey
      } catch (error) {
        this.$message.error(error?.message)
      }
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      let tempIndexArray = []
      const showHeaderInfo = this.listOption.filter(el => el.isShow) || []
      if (this.showAward || this.inMultiple) {
        tempIndexArray = [...Array(showHeaderInfo.length + 2).keys()]
      } else {
        tempIndexArray = [...Array(showHeaderInfo.length + 1).keys()]
      }
      if (this.inMultiple) tempIndexArray.push(3)
      if (tempIndexArray.indexOf(columnIndex) > -1) {
        if (rowIndex % this.spanNum === 0) {
          return {
            rowspan: this.spanNum,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },

    // 已选项变化
    handleSelectionChange(selection) {
      const materialIds = []
      selection.forEach(v => {
        materialIds.push(v.materielId)
      })
      this.$emit('selected', materialIds)
    },

    /**
     * 是否有公司已授标
     */
    checkIsHasGrand() {
      // 检查是否有公司已授标
      const hasCheck = this.supplierHead.some(
        item => item.checkedMaterial.length > 0
      )
      return new Promise((resolve, reject) => {
        if (hasCheck) {
          this.$antConfirm({
            title: '授标确认',
            content: '有公司存在授标信息，确定后将取消其他公司的授标信息',
            icon: () => <a-icon type='exclamation-circle' />,
            onOk: () => {
              for (let i = 0; i < this.tableDataTemp.length; i++) {
                const row = this.tableDataTemp[i]
                for (const i in row.offerValue) {
                  row.offerValue[i].check = false
                  row.offerValue[i].num = ''
                }
              }
              this.supplierHead.forEach(item => {
                item.checkAll = false
                item.isIndeterminate = false
                item.checkedMaterial = []
              })
              resolve(true)
            }
          })
        } else {
          resolve(true)
        }
      })
    },

    // 一键选择最低价
    async handleSelectLowest() {
      const tempArr = this.tableDataTemp

      if (JSON.stringify(tempArr[0].offerValue) === '{}') {
        this.$message.warning('无最低报价')
        return false
      }

      // 检查是否有公司已授标
      await this.checkIsHasGrand()

      // 设置授标方式
      this.setAwardMethod(awardMethodDict.SUBITEM.value)

      tempArr.forEach(v => {
        const lowSupplierId = v.lowOffer?.supplierId
        if (lowSupplierId) {
          v.offerValue[lowSupplierId].check = true
          v.offerValue[lowSupplierId].num = Number(v.materielNum || 0)
        }
      })
    },

    /**
     * 一键选择总价最低
     */
    handleSelectLowestTotal() {
      // 过滤出所有选择授标量的行
      const tempArr = this.tableDataTemp

      if (JSON.stringify(tempArr[0]?.offerValue) === '{}') {
        this.$message.warning('无最低报价')
        return false
      }

      // 获取最低总价
      const mixValue = Math.min.apply(
        Math,
        this.supplierHead.map(o => o.noRateOfferAmount)
      )

      // 获取总价最低的供应商，若有多个总价最低供应商，则根据报价时间顺序选择最早报价的供应商
      const supplierList = this.supplierHead.filter(
        item => item.noRateOfferAmount == mixValue
      )
      supplierList.sort((a, b) => {
        if (a.offerTime > b.offerTime) {
          return 1
        } else {
          return -1
        }
      })

      if (!supplierList[0]?.checkAll) {
        this.handleSupplierCheck(supplierList[0], true)
      }
    },

    // 获取单个品目的授标总量
    getAwardNum(row) {
      let awardNum = 0
      this.tableDataTemp.forEach((v, index) => {
        if (
          (index + 1) % this.spanNum === 0 &&
          v.materielId === row.materielId
        ) {
          const tempOffer = v.offerValue
          Object.keys(tempOffer).find(key => {
            if (tempOffer[key].check) {
              awardNum =
                (awardNum * 100 + (tempOffer[key].num || 0) * 100) / 100
            }
          })
        }
      })

      return awardNum.toFixed(2)
    },

    // 导出比价结果
    exportCompareInfo() {
      this.$emit('export')
    },

    /**
     * 单个供应商单个品目勾选变化
     * @param {Object} row 当前行信息
     * @param {Object} supplier 当前列的供应商数据
     */
    checkChange(row, supplier) {
      const tempObj = row.offerValue?.[supplier.supplierId]

      if (tempObj.check) {
        tempObj.check = false
        tempObj.num = ''
        const tempIndex = supplier.checkedMaterial.indexOf(row.materielId)
        supplier.checkedMaterial.splice(tempIndex, 1)
      } else {
        tempObj.check = true
        tempObj.num = Number(row.materielNum || 0)
        supplier.checkedMaterial.push(row.materielId)

        for (const k in row.offerValue) {
          if (k != supplier.supplierId) {
            row.offerValue[k].check = false
            row.offerValue[k].num = ''
          }
        }
      }
    },

    /**
     * 前端模拟分页：获取分页数据
     */
    getPageData() {
      const start = (this.page - 1) * this.sizeMultiple
      const end = start + this.sizeMultiple
      this.pageTableData = this.tableDataTemp.slice(start, end)
    },

    /**
     * 根据当前分页与已选数据，进行反选
     */
    getIntersectionAndSelect() {
      // 取交集
      const intersection = [...this.tableDataTemp].filter(x =>
        [...this.echoList].some(y => y === x.materielId)
      )
      // 取差集
      const difference = [...this.tableDataTemp].filter(x =>
        [...intersection].every(y => y.materielId !== x.materielId)
      )

      if (this.echoList.length > 0) {
        intersection.forEach(item => {
          this.$refs.table?.toggleRowSelection(item, true)
        })
        difference.forEach(item => {
          this.$refs.table?.toggleRowSelection(item, false)
        })
      } else {
        this.$refs.table?.clearSelection()
      }
    },

    getOfferColor(row, supplier) {
      const info = this.getOfferValue(row, supplier)

      if (info.high) return 'text-danger'

      if (info.low) return 'text-success'

      return ''
    },

    getGrandCheck(row, supplier) {
      const info = row.offerValue?.[supplier.supplierId] || {}
      return info
    },

    /**
     * 设置供应商表头排序
     */
    setSupplierHead() {
      const tempList = cloneDeep(this.headerList) || []
      if (this.inviteSupplierList.length) {
        this.supplierHead = this.inviteSupplierList.map(supplier => {
          const offerSupplier = tempList.find(
            item => item.supplierId === supplier.supplierId
          )
          if (offerSupplier?.supplierId) {
            return offerSupplier
          }
          return supplier
        })
      } else {
        this.supplierHead = tempList.map(item => {
          item.checkedMaterial = []
          item.someDisabled = 0
          for (
            let i = this.spanNum - 1;
            i < this.tableDataTemp.length;
            i += this.spanNum
          ) {
            const offerValue =
              this.tableDataTemp[i].offerValue[item.supplierId] || {}
            if (offerValue?.check) {
              item.checkedMaterial.push(this.tableDataTemp[i].materielId)
            }
            if (!offerValue.detailId) {
              item.someDisabled++
            }
          }
          // 检查当前供应商是否所有品目都授标
          const checkAll =
            item.checkedMaterial.length ===
            this.tableDataTemp.length / this.spanNum - item.someDisabled
          // 检查当前供应商是否有部分品目授标
          const someCheck = item.checkedMaterial.length > 0
          item.isIndeterminate = !checkAll && someCheck
          item.checkAll = checkAll
          return item
        })
      }

      this.tableKey = !this.tableKey
    },

    /**
     * 修改供应商排序
     */
    handleChangeSort() {
      this.$emit('changeSort', this.sortType)
    },

    /**
     * 设置授标方式
     */
    setAwardMethod(value) {
      this.$emit('update:awardType', value)
    },

    /**
     * 处理供应商表头勾选事件
     * @params supplier 供应商信息
     * @params isSetAwardMethodFlag 是否设置授标方式
     */
    handleSupplierCheck(supplier, isSetAwardMethodFlag) {
      if (!supplier.checkAll) {
        // 先检查是否有其他公司已授标
        const otherCheck = this.supplierHead.some(item => {
          return (
            item.supplierId !== supplier.supplierId &&
            item.checkedMaterial.length > 0
          )
        })
        if (otherCheck) {
          this.$antConfirm({
            title: '授标确认',
            content: '有其他公司存在授标信息，确定后将取消其他公司的授标信息',
            icon: () => <a-icon type='exclamation-circle' />,
            onOk: () => {
              for (
                let i = this.spanNum - 1;
                i < this.tableDataTemp.length;
                i += this.spanNum
              ) {
                const row = this.tableDataTemp[i]
                for (const i in row.offerValue) {
                  row.offerValue[i].check = false
                  row.offerValue[i].num = ''
                }
              }
              this.supplierHead.forEach(item => {
                item.checkAll = false
                item.isIndeterminate = false
                item.checkedMaterial = []
              })

              isSetAwardMethodFlag &&
                this.setAwardMethod(awardMethodDict.TOTAL.value)
              this.handleSupplierCheckAll(supplier)
            }
          })
          return
        }
        if (supplier.isIndeterminate) {
          // 在有部分已选的情况下，先弹窗待用户确认，再进行全选
          this.$antConfirm({
            title: '全部授标确认',
            content: '当前存在部分授标情况，确定后将全部授标',
            icon: () => <a-icon type='exclamation-circle' />,
            onOk: () => {
              isSetAwardMethodFlag &&
                this.setAwardMethod(awardMethodDict.TOTAL.value)
              this.handleSupplierCheckAll(supplier)
            }
          })
          return
        }
        isSetAwardMethodFlag && this.setAwardMethod(awardMethodDict.TOTAL.value)
        this.handleSupplierCheckAll(supplier)
      } else {
        isSetAwardMethodFlag && this.setAwardMethod(awardMethodDict.TOTAL.value)
        this.handleSupplierCheckAll(supplier)
      }
    },

    /**
     * 供应商全选授标处理
     * @param {Object} supplier 供应商表头信息
     */
    handleSupplierCheckAll(supplier) {
      supplier.checkAll = !supplier.checkAll

      // 如果全选，则将当前供应商的所有品目全勾选
      if (supplier.checkAll) {
        supplier.isIndeterminate = false
        for (
          let i = this.spanNum - 1;
          i < this.tableDataTemp.length;
          i += this.spanNum
        ) {
          const row = this.tableDataTemp[i]
          if (row.offerValue[supplier.supplierId].detailId) {
            row.offerValue[supplier.supplierId].check = true
            row.offerValue[supplier.supplierId].num = row.materielNum
            supplier.checkedMaterial.push(row.materielId)
          }
        }
      } else {
        // 如果取消权限，则将当前供应商的所有品目清除授标
        this.$antConfirm({
          title: '全部取消授标确认',
          content: '确定后将所有品目取消授标',
          icon: () => <a-icon type='exclamation-circle' />,
          onOk: () => {
            for (
              let i = this.spanNum - 1;
              i < this.tableDataTemp.length;
              i += this.spanNum
            ) {
              const row = this.tableDataTemp[i]
              row.offerValue[supplier.supplierId].check = false
              row.offerValue[supplier.supplierId].num = ''
            }
            supplier.checkedMaterial = []
          },
          onCancel: () => {
            // 如果点击取消，则需要恢复全选
            supplier.checkAll = true
          }
        })
      }
    },

    // 下载pdf
    async handleExportPdf() {
      const pdfData = await this.getPdfData()
      if (JSON.stringify(pdfData) == '{}') {
        return false
      }
      const tableHtml = await generateMaterielOfferHtml({
        pdfData,
        isDollar: this.isDollar,
        pdfTitle: '询比比价表',
        requireTax: this.requireTax
      })
      this.downloadPdf(tableHtml)
    },

    // 获取比价表pdf数据
    getPdfData() {
      return new Promise((resolve, reject) => {
        const params = {
          orderId: this.orderId
        }
        getInquiryOfferComparePdfApi(
          this.orderId,
          this.roundId,
          JSON.parse(this.sortType)
        )
          .then(res => {
            const data = res?.data || {}
            resolve(data)
          })
          .catch(err => {
            if (err?.message) this.$message.error(err.message)
            throw err
          })
      })
    },

    // 下载pdf
    downloadPdf(content) {
      const postData = {
        name: `询比比价表.pdf`,
        watermark: {
          watermarkType: watermarkTypeDict.ORDINARY_TEXT.value, // 水印类型
          watermarkWord: '精彩纵横云采购平台'
        },
        content: content
      }
      htmlToPdfApi(postData)
        .then(res => {
          getFileUrlByFileIdApi({ attachmentId: res.data }).then(fileRes => {
            window.open(fileRes.data.external, '_self')
          })
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
          throw err
        })
    },

    getOfferValue(row, item) {
      return row.offerValue[item.supplierId] || {}
    },

    /**
     * 获取受邀供应商未报价原因
     * @param inviteSupplier
     * @returns {string}
     */
    getSupplierOfferLabel(inviteSupplier) {
      if (inviteSupplier.acceptStatus === inviteStatusDict.REJECTED.value) {
        return '拒绝报价'
      }
      return '未报价'
    }
  }
}
</script>

<style lang="scss" scoped>
.compare-wrap {
  margin: 20px 0;

  .compare-tips {
    .compare-tips__item {
      &::before {
        content: '';
        display: inline-block;
        width: 16px;
        height: 16px;
        border-radius: 2px;
        margin-right: 8px;
      }

      &.lowest::before {
        background-color: $success-color;
      }

      &.highest::before {
        background-color: $danger-color;
      }

      & + .compare-tips__item {
        margin-left: 10px;
      }
    }
  }

  .compare-table {
    margin-top: 20px;
  }
}

.multiple-tips {
  font-size: pixel-to-rem($n: 20);
  color: $third-text-color;

  &::before {
    content: '*';
    color: $danger-color;
    padding-right: pixel-to-rem($n: 4);
  }

  .multiple-tips__important {
    color: $text-color;
    display: inline-block;
    margin-right: pixel-to-rem($n: 20);
  }
}

.table-item {
  .column {
    flex: 1;

    .column-item {
      display: flex;
      align-items: flex-start;

      .column-item__title {
        @include text-bold;
        white-space: nowrap;
        flex: 1;
        text-align: right;

        &::after {
          content: '：';
          display: inline-block;
        }
      }

      .column-item__content {
        flex: 1;
        margin: 0;
        text-align: left;
      }
    }
  }
}
.no-current-round {
  color: $warning-color;
}
::v-deep {
  .el-table th {
    border-top: none;
  }
}
</style>
